import React from 'react';
import { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';

import { FGrid, FGridMoneyCell } from '../grid';
import { IAllocationLineItem } from './budgetallocation.models';

type Props = {
  rows: IAllocationLineItem[];
  selection: GridRowSelectionModel;
  loading?: boolean;
  onSelectionChange: (selection: GridRowSelectionModel) => void;
};

class BudgetAllocationLineItemGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'shortcode', headerName: 'Account Code', width: 150 },
    { field: 'recname', headerName: 'Budget Line Item', flex: 1, minWidth: 320 },
    { field: 'code_length', headerName: 'Digits', width: 85, type: 'number' },
    { field: 'allocation_count', headerName: 'Links', width: 90, type: 'number' },
    { field: 'allocated_amount', headerName: 'Allocated', width: 140, renderCell: FGridMoneyCell },
  ];

  render() {
    return (
      <FGrid
        title="Budget Line Items"
        subtitle="Select one or more line items to map to selected activities."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={520}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#e7f6ea' }}
        getRowId={(row: any) => row.recid || row.id}
        checkboxSelection
        rowSelectionModel={this.props.selection}
        onRowSelectionModelChange={this.props.onSelectionChange}
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
      />
    );
  }
}

export default BudgetAllocationLineItemGrid;
